import { FC } from 'react';
import { DoorScreenDisplayType, doorScreenDisplayType, locationStatus } from '../../../enums';
import '../../../styles/workplace.scss';
import { IDoorScreenlColorsForm } from '../../administration/organization/generalSettings/design/GeneralSettingsDesignDoorScreen';
import { IPractitionerWorkTime } from './models';

interface FullViewProps {
    design: IDoorScreenlColorsForm;
    practitionerToShow: IPractitionerWorkTime | null;
}

const DoorSreenPractitionerInfoView: FC<FullViewProps> = (props: FullViewProps) => {
    return (
        <div>
            <div
                className="practitionerDetailedInformation"
                style={{
                    color: props.design.primaryColor?.toString()
                }}
            >
                {props.practitionerToShow.firstName && props.practitionerToShow.lastName && (
                    <div>
                        <span
                            style={{
                                fontSize: props.practitionerToShow.firstName.length + props.practitionerToShow.lastName.length > 13 ? '8vw' : ''
                            }}
                        >
                            {props.practitionerToShow.firstName}{' '}
                        </span>
                        <span
                            style={{
                                fontSize: props.practitionerToShow.firstName.length + props.practitionerToShow.lastName.length > 13 ? '8vw' : ''
                            }}
                        >
                            {props.practitionerToShow.lastName}
                        </span>
                    </div>
                )}
            </div>
            <div className="practitionerQualification" style={{ color: props.design.primaryColor?.toString() }}>
                {props.practitionerToShow?.qualification}
            </div>
        </div>
    );
};

export default DoorSreenPractitionerInfoView;
